import React from 'react';

interface IconProps {
	className?: string;
	style?: React.CSSProperties;
}


const AgendaView = (props: IconProps) => {
	return (
		<svg
			fill="none"
			height="12"
			viewBox="0 0 12 12"
			width="12"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.80004 5.06639C1.51098 5.06639 1.26084 4.96373 1.04964 4.75839C0.838976 4.55253 0.733643 4.29973 0.733643 3.99999V2.01679C0.733643 1.71653 0.838976 1.46106 1.04964 1.25039C1.26084 1.03919 1.51098 0.933594 1.80004 0.933594H10.2C10.4998 0.933594 10.7526 1.03919 10.9584 1.25039C11.1638 1.46106 11.2664 1.71653 11.2664 2.01679V3.99999C11.2664 4.29973 11.1638 4.55253 10.9584 4.75839C10.7526 4.96373 10.4998 5.06639 10.2 5.06639H1.80004ZM1.80004 4.19999H10.2C10.2443 4.19999 10.2888 4.18053 10.3336 4.14159C10.3779 4.10266 10.4 4.05546 10.4 3.99999V2.01679C10.4 1.96133 10.3779 1.91119 10.3336 1.86639C10.2888 1.82213 10.2443 1.79999 10.2 1.79999H1.80004C1.75578 1.79999 1.71124 1.82213 1.66644 1.86639C1.62218 1.91119 1.60004 1.96133 1.60004 2.01679V3.99999C1.60004 4.05546 1.62218 4.10266 1.66644 4.14159C1.71124 4.18053 1.75578 4.19999 1.80004 4.19999ZM1.80004 11.0664C1.51098 11.0664 1.26084 10.9611 1.04964 10.7504C0.838976 10.5392 0.733643 10.2835 0.733643 9.98319V7.99999C0.733643 7.71093 0.838976 7.46079 1.04964 7.24959C1.26084 7.03893 1.51098 6.93359 1.80004 6.93359H10.2C10.4998 6.93359 10.7526 7.03893 10.9584 7.24959C11.1638 7.46079 11.2664 7.71093 11.2664 7.99999V9.98319C11.2664 10.2835 11.1638 10.5392 10.9584 10.7504C10.7526 10.9611 10.4998 11.0664 10.2 11.0664H1.80004ZM1.80004 10.2H10.2C10.2443 10.2 10.2888 10.1779 10.3336 10.1336C10.3779 10.0888 10.4 10.0387 10.4 9.98319V7.99999C10.4 7.94453 10.3779 7.89733 10.3336 7.85839C10.2888 7.81946 10.2443 7.79999 10.2 7.79999H1.80004C1.75578 7.79999 1.71124 7.81946 1.66644 7.85839C1.62218 7.89733 1.60004 7.94453 1.60004 7.99999V9.98319C1.60004 10.0387 1.62218 10.0888 1.66644 10.1336C1.71124 10.1779 1.75578 10.2 1.80004 10.2Z"
				fill="#5D5F69"
			/>
		</svg>
	);
};

export default AgendaView;
